import React from "react";
import styles from "./styles.module.scss";

let placeholder = document.createElement("li");
placeholder.className = styles.placeholder;

export default class DraggableList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ...props };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.movable !== prevProps.movable) {
            this.setState({ movable: this.props.movable });
        }
        if (this.props.selectedIdx !== prevProps.selectedIdx) {
            this.setState({ selectedIdx: this.props.selectedIdx });
        }
        if (this.props.list?.toString() !== prevProps.list?.toString()) {
            this.setState({ list: this.props.list });
        }
    }

    dragStart(e) {
        if (!this.props.movable) return;
        this.props.setSelectedIdx(null);
        this.dragged = e.currentTarget;
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("text/html", this.dragged);
    }

    dragEnd(e) {
        if (!this.props.movable) return;
        if (!this.dragged) return;
        this.dragged.style.display = "block";
        let to = Array.prototype.indexOf.call(
            this.dragged.parentNode.children,
            placeholder
        );
        this.dragged.parentNode.removeChild(placeholder);
        var data = this.state.list;
        var from = Number(this.dragged.dataset.id);
        if (from < to) to--;
        this.state.list.splice(to, 0, data.splice(from, 1)[0]);
        this.setState({ list: data });
        this.props.setList(data);
        this.props.setSelectedIdx(to);
        this.dragged = null;
    }

    dragOver(e) {
        if (!this.props.movable) return;
        if (!this.dragged) return;
        e.preventDefault();
        this.dragged.style.display = "none";
        if (
            e.target.className === styles.placeholder ||
            e.target.tagName.toLowerCase() !== "li" // if drag over other element, just return
        )
            return;
        const overId = Number(e.target.dataset.id);
        if (
            overId === e.target.parentNode.children.length - 2 &&
            e.pageY - e.target.getBoundingClientRect().top > 17
        ) {
            // put at the end of the list
            e.target.parentNode.insertBefore(placeholder, null);
        } else {
            e.target.parentNode.insertBefore(placeholder, e.target);
        }
    }

    render() {
        const { title, className, selectedIdx, setSelectedIdx, movable } =
            this.state;
        return (
            <div className={className}>
                <span className={styles.subTitle}>{title}</span>
                <ul
                    className={styles.inner}
                    onDragOver={(e) => this.dragOver(e)}
                >
                    {this.state.list &&
                        this.state.list.map((element, index) => {
                            return (
                                <li
                                    draggable="true"
                                    onDragEnd={(e) => this.dragEnd(e)}
                                    onDragStart={(e) => this.dragStart(e)}
                                    data-id={index}
                                    data-testid={`li-${title}-${element.name}`}
                                    onClick={() => setSelectedIdx(index)}
                                    className={[
                                        styles.list,
                                        selectedIdx === index
                                            ? styles.selected
                                            : "",
                                        movable ? styles.movable : "",
                                    ].join(" ")}
                                    key={`list-${element.value}-${index}`}
                                >
                                    {element.name}
                                </li>
                            );
                        })}
                </ul>
            </div>
        );
    }
}
